document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.contact-form-wrapper');
    const fileURl = document.querySelector('[data-css-url]');
    if (!section) {
        console.warn('section-contact-js not found');
        return;
    }
    const observer = new MutationObserver(() => {

        const form = section.querySelector('form-embed');

        if (form && form.shadowRoot) {
            observer.disconnect();

            const shadow = form.shadowRoot;
            const cssPath = fileURl.dataset.cssUrl;

            if (!shadow.querySelector(`link[href="${cssPath}"]`)) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = cssPath;
                shadow.appendChild(link);
                console.log('contact-us-style.css injected into form-embed shadow root');
            }

            form.classList.add('loaded');
        }
    });

    observer.observe(section, {childList: true, subtree: true});
});